const treatmentBenefits = [
  "Ausscheidung aller angesammelten Abfallstoffe und Giftstoffe",
  "Wiederherstellung der verlorenen inneren Balance und Harmonie",
  "Sanfte Reinigung gestauter Energien und Blockaden",
  "Gesunde Regeneration von Gewebe und Organen",
  "Sp\xFCrbare St\xE4rkung der nat\xFCrlichen Immunit\xE4t",
  "Entspannung bei t\xE4glichem Stress und F\xF6rderung eines tiefen Schlafs",
  "Anregung des Blut- und Lymphkreislaufs f\xFCr eine bessere Durchblutung",
  "Sanfte Verbesserung der gesamten Verdauung und des Stoffwechsels",
  "Gl\xE4nzende Haut und kr\xE4ftiges Haar, die von innen heraus strahlen",
  "Reduzierung entz\xFCndlicher Beschwerden im K\xF6rper",
  "Vorbeugung von Migr\xE4ne und Kopfschmerzen"
];
const Treatments = () => {
  return <section className="relative isolate w-full overflow-hidden bg-[#07130d] py-16 sm:py-20 lg:py-28">
            <img
    src="/images/ayurveda-massage-treatment.webp"
    alt="Ayurvedische Behandlung"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
            <div className="absolute inset-0 bg-black/65" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/60 to-black/75" />

            <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center text-white">
                    <div className="mx-auto h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />
                    <p className="mt-6 font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-100">
                        Individuelle Heilung
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                        Maßgeschneiderte Behandlungen für jeden Einzelnen
                    </h2>
                    <div className="mt-8 space-y-6 font-mulish text-base leading-8 text-white/90 sm:text-lg">
                        <p>
                            Im Ayurveda gibt es eine Vielzahl von Behandlungsmethoden. Im Resort analysiert ein Arzt sorgfältig den Gesundheitszustand jedes Gastes und wählt die Therapie mit der größten positiven Wirkung auf den Körper behutsam und individuell aus.
                        </p>
                        <p>
                            Je nach Tageszustand und persönlichen Bedürfnissen kann die Behandlung von intensiver Therapie bis zu sanfter Begleitung angepasst werden. Diese Anwendungen sind essenziell, um Ablagerungen, Blockaden und innere Disharmonien von Körper, Geist und Seele sanft zu lösen. Die Stille der Behandlung und die wohltuende Stimulation bestimmter Reflexzonen fördern tiefe Entspannung und innere Balance.
                        </p>
                    </div>
                </div>

                <div className="mx-auto mt-12 max-w-5xl rounded-[24px] border border-white/20 bg-white/10 p-6 text-white shadow-2xl backdrop-blur-md sm:p-8 lg:p-10">
                    <h3 className="text-center font-serif text-2xl font-semibold text-amber-100 sm:text-3xl">
                        Die vielen Vorteile der Ayurveda-Behandlung
                    </h3>
                    <p className="mx-auto mt-4 max-w-3xl text-center font-mulish text-base leading-8 text-white/90 sm:text-lg">
                        Durch regelmäßige, achtsame Behandlungen entstehen im Körper und Geist wunderbare Veränderungen.
                    </p>
                    <ul className="mt-7 grid gap-x-8 gap-y-3 font-mulish text-[15px] leading-7 text-white/90 sm:grid-cols-2 sm:text-base">
                        {treatmentBenefits.map((benefit) => <li key={benefit} className="flex gap-3">
                                <span className="mt-3 h-2 w-2 shrink-0 rounded-full bg-[#F28600]" />
                                <span>{benefit}</span>
                            </li>)}
                    </ul>
                </div>
            </div>
        </section>;
};
export default Treatments;
